import React from "react";

import ChevronIcon from "components/Icons/ChevronIcon";

export type BreadcrumbProps = {
  arrowWidth?: number;
  children?: React.ReactNode;
  /**
   * The breadcrumb that represents the current page should be marked with the
   * `currentLocation` prop. This will both add the required ARIA attributes
   * and style the breadcrumb correctly. This should only ever be used on the
   * final breadcrumb in the sequence.
   */
  currentLocation?: boolean;
  href?: string;
  testId?: string;
};

const Breadcrumb: React.FC<BreadcrumbProps> = ({
  arrowWidth = 14,
  children,
  currentLocation = false,
  href,
  testId,
}) => {
  const showNavigationalArrow = !currentLocation;

  return (
    <li className="breadcrumb__item">
      <a
        aria-current={currentLocation ? "location" : undefined}
        className="breadcrumb__link"
        href={href}
        data-testid={testId}
      >
        {children}
      </a>
      {showNavigationalArrow && (
        <ChevronIcon
          width={`${arrowWidth}`}
          height={`${arrowWidth}`}
          direction="right"
        />
      )}
    </li>
  );
};

export default Breadcrumb;
